import { Circle } from '@untitledui/icons';
import { CenterOpenState } from '../../../types/gcs/center';
import { Icon } from '../../../components/general/Icon';
import { en } from '../../../locales/en';

interface CenterOpenStateIconProps {
  centerOpenState: CenterOpenState | null;
  size?: number;
}

const UNKNOWN_COLOR = '#9ca3af';

const getCenterOpenStateColor = (openState: CenterOpenState | null) => {
  if (!openState) return UNKNOWN_COLOR;
  switch (openState) {
    case CenterOpenState.CENTER_OPEN:
      return '#22c55e'; // green
    case CenterOpenState.CENTER_OPENING_CHECKLIST:
      return '#f59e0b'; // yellow
    case CenterOpenState.CENTER_OPEN_SERVICE_CLOSED:
      return '#f97316'; // orange
    case CenterOpenState.CENTER_OPEN_CAN_BE_CLOSED:
      return '#f59e0b'; // yellow
    case CenterOpenState.CENTER_CLOSING_CHECKLIST:
      return '#f97316'; // orange
    case CenterOpenState.CENTER_CLOSED:
      return '#ef4444'; // red
    default:
      return UNKNOWN_COLOR;
  }
};

const getCenterOpenStateTitle = (openState: CenterOpenState | null) => {
  if (!openState) return en.centerStatusTitles.unknown;
  switch (openState) {
    case CenterOpenState.CENTER_OPEN:
      return en.centerStatusTitles.centerOpen;
    case CenterOpenState.CENTER_OPENING_CHECKLIST:
      return en.centerStatusTitles.centerOpeningChecklist;
    case CenterOpenState.CENTER_OPEN_SERVICE_CLOSED:
      return en.centerStatusTitles.centerOpenServiceClosed;
    case CenterOpenState.CENTER_OPEN_CAN_BE_CLOSED:
      return en.centerStatusTitles.centerOpenCanBeClosed;
    case CenterOpenState.CENTER_CLOSING_CHECKLIST:
      return en.centerStatusTitles.centerClosingChecklist;
    case CenterOpenState.CENTER_CLOSED:
      return en.centerStatusTitles.centerClosed;
    default:
      return en.centerStatusTitles.unknown;
  }
};

export default function CenterOpenStateIcon({ centerOpenState, size = 20 }: CenterOpenStateIconProps) {
  return (
    <Icon
      icon={Circle}
      size={size}
      color={getCenterOpenStateColor(centerOpenState)}
      title={getCenterOpenStateTitle(centerOpenState)}
    />
  );
}
